export function getApiEndpoint() {
    return window.location.origin;
}
